import React, { useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import {
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonList,
  IonLoading,
  IonRefresher,
  IonRefresherContent,
} from '@ionic/react';
import { useSelector, useDispatch } from 'react-redux';
import OrderActions, { OrderSelectors } from 'redux/OrderRedux';
import { AuthSelectors } from 'redux/AuthRedux';
import { searchOutline } from 'ionicons/icons';
import api_v2 from 'services/api_v2';
import MenuItem from './MenuItem';
import CategoryItem from './CategoryItem';
import CategoryTab from './CategoryTab';

function MenuItemList({ venueId, prefix }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [search, setSearch] = useState('');
  const contentRef = useRef(null);
  const categories = useSelector(OrderSelectors.selectTabCategories(venueId));
  const [category, setCategory] = useState(null);
  const items = useSelector(OrderSelectors.selectAllItemsWithCategory(venueId));
  const loading = useSelector(OrderSelectors.selectMenuItemsLoading);
  const token = useSelector(AuthSelectors.selectToken);

  const filteredItems = useMemo(() => {
    const result = items.filter(
      (item) =>
        item.kind === 'category' ||
        search === '' ||
        item.name.toLowerCase().includes(search.toLowerCase())
    );

    return result;
  }, [search, items]);

  const handleLoadItems = async (e) => {
    const api = api_v2(token);

    try {
      const resp = await api.getMenuItems(venueId);
      dispatch(OrderActions.setMenuItems(venueId, resp));
    } catch (err) {
      console.log("get menu item error: ", err.message);
    }

    e.detail.complete();
  };

  const handleClick = (item) => {
    history.push(`${prefix}/${item.id}`);
  };

  const handleChangeCategory = (newCategory) => {
    setCategory(newCategory);
    if (contentRef.current) {
      const el = document.getElementById(newCategory);

      if (el) {
        contentRef.current.scrollToPoint(0, el.offsetTop, 300);
      }
    }
  };

  return (
    <>
      <IonHeader>
        <IonList>
          <IonItem>
            <IonIcon slot="start" icon={searchOutline} />
            <IonInput
              value={search}
              placeholder="Search all items"
              onIonChange={(e) => setSearch(e.detail.value)}
            />
          </IonItem>
        </IonList>
        <CategoryTab
          categories={categories}
          onChange={handleChangeCategory}
          value={category}
        />
      </IonHeader>

      <IonContent ref={contentRef} className="menu-item-content">
        <IonLoading isOpen={loading} message="Loading..." />
        <IonRefresher slot="fixed" onIonRefresh={handleLoadItems}>
          <IonRefresherContent />
        </IonRefresher>

        <IonList>
          {filteredItems.map((item) =>
            item.kind === 'category' ? (
              <CategoryItem key={item.id} item={item} />
            ) : (
              <MenuItem
                key={item.id}
                item={item}
                onClick={() => handleClick(item)}
              />
            )
          )}
        </IonList>
      </IonContent>
    </>
  );
}

MenuItemList.propTypes = {
  prefix: PropTypes.string,
  venueId: PropTypes.string.isRequired,
};

export default MenuItemList;
